// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3T4Um","requiredAsterisk":"Info_requiredAsterisk__2bJlS"};